<template>
  <Upload class="upload-in-table"
          :format="formatList"
          :before-upload="beforeUploadFile"
          action="">
    <Icon class="upload-icon" type="md-cloud-upload" title="上传"/>
  </Upload>
</template>

<script>
  export default {
    name: "upload-in-table",
    props: {
      row: Object,
      formatList: Array,
    },
    methods: {
      beforeUploadFile(file) {
        let fileType = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (!this.formatList.includes(fileType)) {
          this.$Notice.error({title: '文件格式错误：', desc: '不支持.' + fileType + '格式,请上传Excel文件'});
        } else {
          let form = new FormData();
          form.append('file', file);
          this.$emit('on-upload', form)
          return false;
        }
      },
    }
  }
</script>

<style scoped>
  .upload-in-table {
    display: inline-block;
  }

  .upload-icon {
    font-size: 16px;
    margin-left: 16px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/my-components/upload-in-table/upload-in-table.vue